import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CustomerProject  {
    _originalTypeClassName = "zERP.BO.CustomerProject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CustomerProject.translate = translateService;
}
this.CustomerProjectTrans = [];
this.Id = null;
this.StartDate = null;
this.EndDate = null;
this.StreetName = null;
this.StreetNumber = null;
this.City = null;
this.PostalCode = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StartDate:any;
EndDate:any;
StreetName:any;
StreetNumber:any;
City:any;
PostalCode:any;
Code:any;
Project:any;
EmployeeContract:any;
CustomerProjectTrans:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setCustomerProjectTrans = ($this, items) => {
                if (items == null) items = [];
                if ($this.CustomerProjectTrans == null) $this.CustomerProjectTrans = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CustomerProjectTrans.length > 0) {
                    Domain.CustomerProject.removeCustomerProjectTrans($this, $this.CustomerProjectTrans[0]);
                }

                Domain.CustomerProject.addManyCustomerProjectTrans($this, copyItems);
            }
static addManyCustomerProjectTrans = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CustomerProject.addCustomerProjectTrans($this, items[i]);
                }
            }
static addCustomerProjectTrans = ($this, item) => {
                if ($this.CustomerProjectTrans == null) $this.CustomerProjectTrans = [];
                if (item == null || $this.CustomerProjectTrans.indexOf(item) > -1) return;
                $this.CustomerProjectTrans.push(item);
}
static addRangeCustomerProjectTrans = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CustomerProject.addCustomerProjectTrans($this, item));
            }
static removeCustomerProjectTrans = ($this, item) => {
                if ($this == null || $this.CustomerProjectTrans == null || $this.CustomerProjectTrans.indexOf(item) === -1) return;
                var _index = $this.CustomerProjectTrans.indexOf(item);
                $this.CustomerProjectTrans.splice(_index, 1);
}
static clearCustomerProjectTrans = ($this) => { $this.CustomerProjectTrans = null; }

static GetClassName(): any{return "CustomerProject";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}